// @ts-ignore
const _formatter = new Intl.DateTimeFormat('en', { dateStyle: 'long', timeStyle: 'medium' });
export function format(date) {
    return _formatter.format(date);
}
export function countdown(to, callback) {
    let reschedule = true;
    let nextSchedule;
    (function scheduledFn() {
        // Find the distance between now and the count down date
        const now = new Date();
        const distance = Math.ceil((to.getTime() - now.getTime()) / 1000);
        if (!reschedule)
            return;
        if (distance > 0) {
            nextSchedule = 1000 - now.getMilliseconds();
            const days = Math.floor(distance / (60 * 60 * 24));
            const hours = Math.floor((distance % (60 * 60 * 24)) / (60 * 60));
            const minutes = Math.floor((distance % (60 * 60)) / 60);
            const seconds = distance % 60;
            callback([days, hours, minutes, seconds]);
            setTimeout(scheduledFn, nextSchedule);
        }
        else {
            callback(null);
        }
    })();
    return () => reschedule = false;
}
